var _style, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightLeg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 310 1520",
    width: 310,
    height: 1520,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".a{fill:#fbc3a4}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m15 409.9c0 217.1 45.8 306 63.2 390.5 5.3 26.5 105.8 104.6 130.4 59.3 5.8-11-9.1-85.9 19-166.2 23.9-68.5 65-196.7 65-305.2 0-90.7-21.4-243.7-37.4-310.2-22.2-92.8-105.1-62.3-144.4-62.3-67.4 0-95.8 80-95.8 394.1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m75.8 1509.2c59-39.2-6.8-264.6-14.7-335.9-22.2-203.5 20.4-417.1 63.9-417.1 25.4 0 64.3-22.2 78.7 65.2 10.2 62.7 7 129.4 25.3 212.8 15.2 69.2-91.3 424.6-54.9 472.4z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m61.1 722.8c0 46.1 36.3 167 73.1 167 36.7 0 66.5-37.5 66.5-83.6 0-46.1-29.8-83.4-66.5-83.4-36.8 0-73.1-46.1-73.1 0z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightLeg);
export default __webpack_public_path__ + "static/media/right_leg.3ed8b3bf37786e9bd4d5a4d3727fe82b.svg";
export { ForwardRef as ReactComponent };